import { render, staticRenderFns } from "./clock.vue?vue&type=template&id=676900d6&"
import script from "./clock.vue?vue&type=script&lang=js&"
export * from "./clock.vue?vue&type=script&lang=js&"
import style0 from "./clock.vue?vue&type=style&index=0&id=676900d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports